import { AppState } from "@shared/interfaces";
import { createSelector } from "reselect";

const selectHospital = (state: AppState) => state.hospital;

export const getHospitals = () => createSelector(selectHospital, (state) => state.hospitals);
export const getHospital = () => createSelector(selectHospital, (state) => state.hospital);
export const getHospitalRolePermissions = () =>
  createSelector(selectHospital, (state) => state.hospitalRolePermissions);
